import React from 'react';

const PresenceDot = ({ online, size = 'small' }) => {
  const sizeClasses = {
    small: 'w-2 h-2',
    medium: 'w-3 h-3',
    large: 'w-4 h-4'
  };

  return (
    <div
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        ${online ? 'bg-green-500' : 'bg-gray-500'}
        ${online ? 'animate-pulse' : ''}
      `}
      title={online ? 'Online' : 'Offline'}
    />
  );
};

export default PresenceDot;
